<template>
  <div class="modalField" :class="{ hasFocus: hasFocus }" ref="cnt">
    <component :is="componente.tipo + '-field'" :item="componente" ref="component" :updateTrigger="updateTrigger" @on-focus="onFocus" @on-blur="onBlur" @cascade-filter="onCascadeFilter" @update-value="onUpdateValue"></component>
  </div>
</template>

<script>
import TextField from './components/TextField'
// import PartitaIvaField from './components/PartitaIvaField'
// import AutocompleteField from './components/AutocompleteField'
import SelectField from './components/AutocompleteField'
// import DatePickerField from './components/DatePickerField'
// import CalendarField from './components/DatePickerField'
// import TimePickerField from './components/TimePickerField'
// import MultiselectField from './components/MultiselectField'
// import SwitchField from './components/SwitchField'
// import RicercaField from './components/RicercaField'
// import InfoListField from './components/InfoListField'
import NumericField from './components/NumericField'
// import IntestazioneField from './components/IntestazioneField'
// import DettaglioField from './components/DettaglioField'
// import ServiziAgendaField from './components/ServiziAgendaField'
import ButtonField from './components/ButtonField'
import TWEEN from 'tween.js'
import * as dot from 'dot-object'

// DEBUG: 02395190545
export default {
  components: {
    TextField,
    // PartitaIvaField,
    // AutocompleteField,
    SelectField,
    // DatePickerField,
    // CalendarField,
    // TimePickerField,
    // MultiselectField,
    // SwitchField,
    // RicercaField,
    // InfoListField,
    NumericField,
    // IntestazioneField,
    // DettaglioField,
    // ServiziAgendaField,
    ButtonField
  },
  props: {
    componente: Object,
    modelItem: Object,
    config: Object,
    updateTrigger: Number
  },
  data() {
    return {
      hasFocus: false
    }
  },
  mounted() {
    // this.$refs.ragioneSociale.focus()
  },
  watch: {
  },
  methods: {
    afterInit() {
      var c = this.$refs.component
      c && c.afterInit && c.afterInit()
    },
    onFocus(event) {
      this.hasFocus = true
      this.$emit('on-focus', this)
    },
    onBlur(event) {
      this.hasFocus = false
      this.$emit('on-blur', this)
      // this.centerField()
    },
    setFocus() {
      var c = this.$refs.component
      this.hasFocus = true
      c && c.setFocus && c.setFocus()
      this.centerField()
    },
    removeFocus() {
      var c = this.$refs.component
      this.hasFocus = false
      c && c.removeFocus && c.removeFocus()
    },
    onKeyInput(value, daTastieraFisica) {
      var c = this.$refs.component
      c && c.onKeyInput && c.onKeyInput(value, daTastieraFisica)
    },
    onCascadeFilter(obj) {
      this.$emit('cascade-filter', obj)
    },
    filtraElementi(campo, valore) {
      var c = this.$refs.component
      c && c.filtraElementi && c.filtraElementi(campo, valore)
    },
    valida() {
      var c = this.$refs.component
      return c && c.valida ? c.valida() : [] // ritorna lista errori
    },
    getDati() {
      var c = this.$refs.component
      return c && c.getDati ? c.getDati() : null
    },
    setValore(valore) {
      var c = this.$refs.component
      c && c.setValore && c.setValore(valore)
    },
    centerField() {
      var modalBody = this.$refs.cnt.parentNode
      var bodyOffset = modalBody.offsetTop
      var componentOffset = this.$refs.cnt.offsetTop - bodyOffset + ((this.$refs.component.customOffset && this.$refs.component.customOffset()) || 0)
      var currScroll = modalBody.scrollTop
      var destScroll = componentOffset - 100

      var scrollTop = { x: currScroll }
      new TWEEN.Tween(scrollTop)
        .to({ x: destScroll }, 250)
        .onUpdate(function() {
          modalBody.scrollTop = this.x
        })
        .start()

      var animate = time => {
        requestAnimationFrame(animate)
        TWEEN.update(time)
      }

      requestAnimationFrame(animate)
    },
    onUpdateValue(value, payload) {
      if (this.config.updateModel && this.modelItem) {
        if (this.componente.model) {
          dot.set(this.componente.model, value, this.modelItem)
        } else {
          this.modelItem[this.componente.campo] = value
        }
      }
      this.componente.onUpdateValue && this.componente.onUpdateValue(value, payload)
    },
    callMethod(methodName, parameters) { // metodo generico da richiamare nel componente dall'esterno ( esempio addServizio del planning )
      var c = this.$refs.component
      return c && c[methodName] ? c[methodName](parameters) : undefined
    }
  }
}
</script>

<style lang="scss">

</style>
